import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ApprovedIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 16 16' className={className}>
    <g id='Group_2217' data-name='Group 2217' transform='translate(-47 -243)'>
      <g
        id='Ellipse_28'
        data-name='Ellipse 28'
        transform='translate(47 243)'
        fill='#57d05a'
        stroke='#fff'
        strokeWidth='1'
      >
        <circle cx='8' cy='8' r='8' stroke='none' />
        <circle cx='8' cy='8' r='7.5' fill='none' />
      </g>
      <path
        id='Path_12586'
        data-name='Path 12586'
        d='M14625.123,9232.507l2.775,3.665,3.886-5.131'
        transform='translate(-14573.78 -8982.273)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1'
      />
    </g>
  </SvgIcon>
);

export default ApprovedIcon;
